import { JetView } from 'webix-jet'; // Importing JetView from the webix-jet library
import { devConfig } from 'config/config'; // Importing development configuration from the config module

/**
 * Class representing a view for table positions.
 * @extends JetView
 */
export default class tablePositionView extends JetView {
    /**
     * Configures the view layout.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        // Retrieve the localization service and its translation function
        const _ = this.app.getService('locale')._;
        // Format date according to the application's date format configuration
        const dateFormat = webix.Date.dateToStr(this.app.config.dateFormat);
        // Preserve the context of 'this' for use in inner functions
        var vthis = this;
        return {
            // Define a Webix datatable view
            view: 'datatable',
            // Unique identifier for the datatable
            id: 'datatablePost',
            // CSS classes for styling the datatable borders
            css: 'webix_header_border webix_data_border webix_footer_border',
            // Enable row selection
            select: true,
            // Enable vertical scrolling based on screen width
            scrollY: screen.width < 820 ? false : true,
            // Define the columns of the datatable
            columns: [
                {
                    // Column for editing entries
                    id: 'rating',
                    header: '',
                    width: 50,
                    height: 25,
                    // Tooltip text for the edit icon
                    tooltip: _('Editar'),
                    // Template function to render the edit icon based on permissions
                    template: function (obj) {
                        // Check if the user has permission to edit
                        if (devConfig.getPermAction('accountingPositionEdit', 'Edit')) {
                            // Return edit icon if permission is granted
                            return "<span class='webix_icon wxi-close edit'></span>";
                        } else {
                            // Return empty string if permission is denied
                            return '';
                        }
                    },
                },
                // Column for displaying the ID
                { id: 'Id', header: 'ID', width: 60, sort: 'int' },
                // Column for displaying the Name with localization
                { id: 'Name', header: _('Nombre'), width: 150, sort: 'int' },
                {
                    // Column for displaying the Type of Position with localization
                    id: 'TypePosition',
                    header: _('Tipo Cargo'),
                    width: 150,
                    sort: 'int',
                },
                {
                    // Column for displaying the State with a combo editor
                    id: 'State',
                    header: _('Estado'),
                    editor: 'combo',
                    // Options for the combo editor
                    options: [
                        { id: 'A', value: _('Activado') },
                        { id: 'I', value: _('Inactivado') },
                    ],
                    width: 100,
                    sort: 'int',
                },
            ],
            // Event handler for click events on the edit icon
            onClick: {
                edit: function (euv, id) {
                    // Trigger the event to open the edit position dialog
                    vthis.app.callEvent('openEditPosit', [{}]);
                },
            },
            // Enable tooltips for the datatable
            tooltip: true,
            // Enable mathematical operations in the datatable
            math: true,
            // Set the data fetching strategy
            loadahead: devConfig.getDefaultDataFetch(),
            // Identifier for the pager component
            pager: 'pagerA',
            // URL for fetching data from the API
            url: devConfig.geturlApi() + 'Accounting/GetPositions',
        }; // Placeholder for the configuration content of the view
    }

    /**
     * Initializes the view after it has been created.
     * @param {Object} grid - The grid component to be initialized.
     */
    init(grid) {
        // Retrieve the localization service from the app
        const _ = this.app.getService('locale')._;
        // Get the URL for the grid data
        var url = grid.data.url;
        // Initialize filter and popup variables
        var filter = '';
        var datePopup = [];
        var popup = '';
        var popupAdd = '';
        // Make an AJAX POST request to fetch types for center position selection
        webix
            .ajax()
            .headers({
                'Content-type': 'application/json', // Set the content type for the request
            })
            .post(
                devConfig.geturlApi() + 'Accounting/GetTypesCenterPositionSelect', // API endpoint
                '{"Type":1}', // Request payload
                {
                    // Handle error response
                    error: function (text, data, XmlHttpRequest) {
                        webix.message('Error! '); // Display error message
                    },
                    // Handle successful response
                    success: function (text, data, XmlHttpRequest) {
                        var resp = JSON.parse(text); // Parse the JSON response
                        datePopup = resp.Data; // Store the data for use in the popup
                        // Create the edit position popup window
                        popup = webix.ui({
                            view: 'window',
                            id: 'EditPosition', // Unique identifier for the window
                            head: {
                                view: 'toolbar',
                                cols: [
                                    { view: 'label', label: _('Editar Cargo') }, // Label for editing position
                                    {
                                        view: 'icon',
                                        icon: 'wxi-close', // Close icon
                                        click: function () {
                                            this.getTopParentView().hide(); // Hide the window on click
                                        },
                                    },
                                ],
                            },
                            position: 'center', // Center the window on the screen
                            modal: true, // Make the window modal
                            body: {
                                view: 'form',
                                id: 'editForm', // Unique identifier for the form
                                elements: [
                                    {
                                        view: 'text',
                                        label: 'ID', // Label for ID field
                                        name: 'Id', // Name of the field
                                        readonly: true, // Make the field read-only
                                    },
                                    {
                                        view: 'text',
                                        label: _('Nombre'), // Label for Name field
                                        name: 'Name', // Name of the field
                                        readonly: true, // Make the field read-only
                                    },
                                    {
                                        view: 'combo',
                                        label: _('Tipo Cargo'), // Label for Type Position field
                                        name: 'TypePosition', // Name of the field
                                        readonly: true, // Make the field read-only
                                    },
                                    {
                                        view: 'combo',
                                        label: _('Estado'), // Label for State field
                                        name: 'State', // Name of the field
                                        options: [
                                            { id: 'A', value: _('Activado') }, // Option for Activated state
                                            { id: 'I', value: _('Inactivado') }, // Option for Inactivated state
                                        ],
                                    },
                                    {
                                        cols: [
                                            {
                                                view: 'button',
                                                value: _('Cancelar'), // Label for Cancel button
                                                click: function () {
                                                    this.getTopParentView().hide(); // Hide the window on click
                                                   $$('editForm').setValues(
                                                        // Reset form values
                                                       $$('editForm').getCleanValues(),
                                                    );
                                                },
                                            },
                                            {
                                                view: 'button',
                                                type: 'form',
                                                value: _('Guardar'), // Label for Save button
                                                click: function ($e) {
                                                    var values =$$('editForm').getValues(); // Get form values
                                                    // Make an AJAX POST request to save the position
                                                    webix
                                                        .ajax()
                                                        .headers({
                                                            'Content-type': 'application/json', // Set content type
                                                        })
                                                        .post(
                                                            devConfig.geturlApi() + 'Accounting/Areas', // API endpoint
                                                            '{"Id":"' +
                                                                values.Id +
                                                                '", "Name":"' +
                                                                values.Name +
                                                                '", "TypePosition":"' +
                                                                values.TypePosition +
                                                                '", "State":"' +
                                                                values.State +
                                                                '"}', // Request payload
                                                            {
                                                                // Handle error response
                                                                error: function (text, data, XmlHttpRequest) {
                                                                    webix.message(_('Error! ')); // Display error message
                                                                },
                                                                // Handle successful response
                                                                success: function (text, data, XmlHttpRequest) {
                                                                    webix.message(
                                                                        _(
                                                                            'Cargo Actualizado', // Display success message
                                                                        ),
                                                                    );
                                                                    grid.clearAll(); // Clear the grid
                                                                    grid.load(
                                                                        url +
                                                                            '?start=0&count=' +
                                                                            grid.data.$pagesize +
                                                                            filter, // Reload the grid data
                                                                    );
                                                                },
                                                            },
                                                        );
                                                   $$('editForm').setValues(
                                                        // Reset form values
                                                       $$('editForm').getCleanValues(),
                                                    );
                                                    this.getTopParentView().hide(); // Hide the window
                                                },
                                            },
                                        ],
                                    },
                                ],
                            },
                        });
                        // Create the add position popup window
                        popupAdd = webix.ui({
                            view: 'window',
                            id: 'AddPosition', // Unique identifier for the window
                            head: {
                                view: 'toolbar',
                                cols: [
                                    { view: 'label', label: _('Añadir Cargo') }, // Label for adding position
                                    {
                                        view: 'icon',
                                        icon: 'wxi-close', // Close icon
                                        click: function () {
                                            this.getTopParentView().hide(); // Hide the window on click
                                        },
                                    },
                                ],
                            },
                            position: 'center', // Center the window on the screen
                            modal: true, // Make the window modal
                            body: {
                                view: 'form',
                                id: 'addformPosition', // Unique identifier for the form
                                elements: [
                                    {
                                        view: 'text',
                                        label: _('Nombre'), // Label for Name field
                                        name: 'Name', // Name of the field
                                        required: true, // Make the field required
                                        labelWidth: 100, // Set label width
                                    },
                                    {
                                        view: 'combo',
                                        label: _('Tipo Cargo'), // Label for Type Position field
                                        name: 'TypePosition', // Name of the field
                                        options: datePopup, // Options populated from the response
                                        required: true, // Make the field required
                                        labelWidth: 100, // Set label width
                                    },
                                    {
                                        view: 'combo',
                                        label: _('Estado'), // Label for State field
                                        name: 'State', // Name of the field
                                        options: [
                                            { id: 'A', value: _('Activado') }, // Option for Activated state
                                            { id: 'I', value: _('Inactivado') }, // Option for Inactivated state
                                        ],
                                        required: true, // Make the field required
                                        labelWidth: 100, // Set label width
                                    },
                                    {
                                        cols: [
                                            {
                                                view: 'button',
                                                value: _('Cancelar'), // Label for Cancel button
                                                click: function () {
                                                    this.getTopParentView().hide(); // Hide the window on click
                                                    $$('addformPosition').setValues(
                                                        // Reset form values
                                                        $$('addformPosition').getCleanValues(),
                                                    );
                                                },
                                            },
                                            {
                                                view: 'button',
                                                type: 'form',
                                                value: _('Guardar'), // Label for Save button
                                                click: function ($e) {
                                                    var values = $$('addformPosition').getValues(); // Get form values
                                                    // Validate the form before submission
                                                    if ($$('addformPosition').validate()) {
                                                        // Make an AJAX POST request to save the new position
                                                        webix
                                                            .ajax()
                                                            .headers({
                                                                'Content-type': 'application/json', // Set content type
                                                            })
                                                            .post(
                                                                devConfig.geturlApi() + 'Accounting/SavePosition', // API endpoint
                                                                '{"Name":"' +
                                                                    values.Name +
                                                                    '", "TypePosition":"' +
                                                                    values.TypePosition +
                                                                    '", "State":"' +
                                                                    values.State +
                                                                    '"}', // Request payload
                                                                {
                                                                    // Handle error response
                                                                    error: function (text, data, XmlHttpRequest) {
                                                                        webix.message(
                                                                            _(
                                                                                'Error! ', // Display error message
                                                                            ),
                                                                        );
                                                                    },
                                                                    // Handle successful response
                                                                    success: function (text, data, XmlHttpRequest) {
                                                                        webix.message(
                                                                            _(
                                                                                'Cargo Agregado', // Display success message
                                                                            ),
                                                                        );
                                                                        grid.clearAll(); // Clear the grid
                                                                        grid.load(
                                                                            url +
                                                                                '?start=0&count=' +
                                                                                grid.data.$pagesize +
                                                                                filter, // Reload the grid data
                                                                        );
                                                                    },
                                                                },
                                                            );
                                                        $$('addformPosition').setValues(
                                                            // Reset form values
                                                            $$('addformPosition').getCleanValues(),
                                                        );
                                                        this.getTopParentView().hide(); // Hide the window
                                                    } else {
                                                        // Display validation error message
                                                        webix.message({
                                                            title: _('¡Error!'),
                                                            type: 'alert-error',
                                                            text: _(
                                                                'Completa los campos...', // Prompt to complete fields
                                                            ),
                                                        });
                                                    }
                                                },
                                            },
                                        ],
                                    },
                                ],
                                elementsConfig: {
                                    on: {
                                        // Validate fields on change
                                        onChange: function () {
                                            this.validate();
                                        },
                                    },
                                },
                            },
                        });
                        // Bind the edit form to the data table
                       $$('editForm').bind($$('datatablePost'));
                    },
                },
            );
        // Listen for the 'position:filter' event on the app instance
        this.on(this.app, 'position:filter', (filterData) => {
            // Convert filterData object into an array of key-value pairs
            var object = Object.entries(filterData);
            var string1 = ''; // Initialize an empty string to build the query parameters

            // Iterate through each key-value pair in the object
            for (var i = 0; i < object.length; i++) {
                // Check if the value is not an object and is not an empty string
                if (typeof object[i][1] !== 'object' && object[i][1] !== '') {
                    // Handle the 'CreatedLocalDate' filter
                    if (object[i][0] == 'CreatedLocalDate') {
                        var date = object[i][1].split(' - '); // Split the date range
                        string1 = string1 + '&dateFrom=' + date[0]; // Add dateFrom to the query string
                        string1 = string1 + '&dateTo=' + date[1]; // Add dateTo to the query string
                    } else {
                        // Handle the 'ModifiedLocalDate' filter
                        if (object[i][0] == 'ModifiedLocalDate') {
                            var date = object[i][1].split(' - '); // Split the date range
                            string1 = string1 + '&dateFrom2=' + date[0]; // Add dateFrom2 to the query string
                            string1 = string1 + '&dateTo2=' + date[1]; // Add dateTo2 to the query string
                        } else {
                            // Add other filters to the query string
                            string1 = string1 + '&' + object[i][0] + '=' + object[i][1];
                        }
                    }
                } else {
                    // Handle cases where the value is an object
                    if (typeof object[i][1] === 'object') {
                        var object2 = Object.entries(object[i][1]); // Convert the nested object to an array
                        // Iterate through each key-value pair in the nested object
                        for (var j = 0; j < object2.length; j++) {
                            // Check if the value is not null
                            if (object2[j][1] !== null) {
                                // Handle the 'start' date
                                if (object2[j][0] === 'start') {
                                    var d = new Date(object2[j][1]); // Create a Date object from the value
                                    var dateFrom =
                                        'dateFrom=' +
                                        d.getFullYear() +
                                        ':' + // Format the date
                                        ('00' + (d.getMonth() + 1)).slice(-2) +
                                        ':' +
                                        ('00' + d.getDate()).slice(-2) +
                                        ' ' +
                                        ('00' + d.getHours()).slice(-2) +
                                        ':' +
                                        ('00' + d.getMinutes()).slice(-2) +
                                        ':' +
                                        ('00' + d.getSeconds()).slice(-2);
                                    string1 = string1 + '&' + dateFrom; // Add dateFrom to the query string
                                } else {
                                    // Handle the 'end' date
                                    if (object2[j][0] === 'end') {
                                        var d = new Date(object2[j][1]); // Create a Date object from the value
                                        var dateTo =
                                            'dateTo=' +
                                            d.getFullYear() +
                                            ':' + // Format the date
                                            ('00' + (d.getMonth() + 1)).slice(-2) +
                                            ':' +
                                            ('00' + d.getDate()).slice(-2) +
                                            ' ' +
                                            ('00' + d.getHours()).slice(-2) +
                                            ':' +
                                            ('00' + d.getMinutes()).slice(-2) +
                                            ':' +
                                            ('00' + d.getSeconds()).slice(-2);
                                        string1 = string1 + '&' + dateTo; // Add dateTo to the query string
                                    }
                                }
                            }
                        }
                    }
                }
            }
            grid.clearAll(); // Clear the grid before loading new data
            // Load the grid with the constructed URL and query parameters
            grid.load(url + '?start=0&count=' + grid.data.$pagesize + string1);
            filter = string1; // Store the constructed filter string
        });
        // Attach an event listener for the 'onAfterSort' event of the grid
        grid.attachEvent('onAfterSort', function (by, dir, as) {
            // Load the grid data with sorting parameters after sorting is completed
            grid.load(
                url +
                    '?start=0&count=' +
                    grid.data.$pagesize + // Set the starting point and count for pagination
                    filter + // Include any additional filters
                    '&sort[' +
                    by + // Sort by the specified column
                    ']=' +
                    dir, // Sort direction (ascending or descending)
            );
        });

        // Listen for the 'addPosition:button' event from the application
        this.on(this.app, 'addPosition:button', (filter) => {
            // Check if there are any items in the datePopup array
            if (datePopup.length > 0) {
                $$('addformPosition').clearValidation(); // Clear any previous validation errors
                popupAdd.show(); // Show the popup for adding a new position
            } else {
                // Display an error message if data could not be loaded
                webix.message({
                    text: _('Datos no han podido ser cargados'), // Error message text
                    title: _('¡Error!'), // Title of the error message
                    type: 'alert-error', // Type of the message
                });
            }
        });

        // Listen for the 'openEditPosit' event from the application
        this.on(this.app, 'openEditPosit', (filterData) => {
            // Check if there are any items in the datePopup array
            if (datePopup.length > 0) {
                popup.show(); // Show the popup for editing a position
            } else {
                // Display an error message if data could not be loaded
                webix.message({
                    text: _('Datos no han podido ser cargados'), // Error message text
                    title: _('¡Error!'), // Title of the error message
                    type: 'alert-error', // Type of the message
                });
            }
        }); // Placeholder for the initialization content of the view
    }
}

// FILE DOCUMENTED
